var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortBySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61111 10.5301H4.05556C4.39167 10.5301 4.66667 10.2551 4.66667 9.919C4.66667 9.58289 4.39167 9.30789 4.05556 9.30789H1.61111C1.275 9.30789 1 9.58289 1 9.919C1 10.2551 1.275 10.5301 1.61111 10.5301ZM1 3.80789C1 4.144 1.275 4.419 1.61111 4.419H11.3889C11.725 4.419 12 4.144 12 3.80789C12 3.47178 11.725 3.19678 11.3889 3.19678H1.61111C1.275 3.19678 1 3.47178 1 3.80789ZM1.61111 7.47456H7.72222C8.05833 7.47456 8.33333 7.19956 8.33333 6.86344C8.33333 6.52733 8.05833 6.25233 7.72222 6.25233H1.61111C1.275 6.25233 1 6.52733 1 6.86344C1 7.19956 1.275 7.47456 1.61111 7.47456Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBySelected);
export default __webpack_public_path__ + "static/media/SortBySelected.70fa22f2f7330ba7e1e3c9cde8fef4cb.svg";
export { ForwardRef as ReactComponent };